import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Collapse,
  Row,
  Button,
} from "reactstrap";
//redux
import { connect } from "react-redux";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// componentes
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import Pagination from "../../../components/Paginationv3";
import ModalNewScreen from "./modalNewScreen";
import ModalEditProduct from "./modalEditScreen";
// service
import {
  getProducts,
  deleteScreenProducts,
} from "../../../utils/services/products";
import useDebounce from "../../../utils/hooks/useDebounce";

function Screens(props) {
  const { isOpen, toggle } = props;
  // modal collapse
  const [isOpenCollapse, setIsOpenCollapse] = useState(false);
  //paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [countData, setCountData] = useState(0);
  const [search, setSearch] = useState("");
  // deletar
  const [deleteData, setDeleteData] = useState({});
  const [confirmDeleteData, setConfirmDelete] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  // modais
  const [modalNewScreen, setModalNewScreen] = useState(false);
  const [modalEditProduct, setModalEditScreen] = useState(false);
  const [editData, setEditData] = useState({});
  // telas
  const [screens, setScreens] = useState([]);
  const debouncedSearch = useDebounce(search, 300);

  function deleteScreen() {
    deleteScreenProducts({
      jwt: props.state.global_user_data.data.token,
      id: deleteData.id,
    }).then((res) => {
      if (res.message === "PRODUCT_DELETED") {
        setDeleteSuccess(true);
        setConfirmDelete(false);
      }
    });
    // .catch((error) => console.log("erro", error));
  }

  function getAllProducts() {
    getProducts({
      jwt: props.state.global_user_data.data.token,
      offset: currentIndex,
      limit: itemsPerPage,
      mainProduct: false,
      columnSearch: "name",
      search: debouncedSearch,
    }).then((res) => {
      if (res.message === "PRODUCTS") {
        setScreens(res.data.products);
        setCountData(res.data.total);
      } else if (res.message === "PRODUCT_NOT_FOUND") {
        setScreens([]);
        setCountData(0);
      } else {
      }
    });
    // .catch((error) => console.log("erro", error));
  }
  useEffect(() => {
    getAllProducts();
  }, [currentIndex, itemsPerPage, debouncedSearch]);

  return (
    <>
      {modalNewScreen && (
        <ModalNewScreen
          isOpen={modalNewScreen}
          toggle={() => setModalNewScreen(!modalNewScreen)}
          getAllProducts={getAllProducts}
        />
      )}

      {modalEditProduct && (
        <ModalEditProduct
          isOpen={modalEditProduct}
          toggle={() => setModalEditScreen(!modalEditProduct)}
          getAllProducts={getAllProducts}
          data={editData}
        />
      )}

      {confirmDeleteData ? (
        <SweetAlert
          title={`Deseja deletar a tela ${deleteData.name}?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            deleteScreen();
          }}
          onCancel={() => setConfirmDelete(false)}
        >
          Você não poderá reverter essa ação!
        </SweetAlert>
      ) : null}

      {deleteSuccess ? (
        <SweetAlert
          success
          title="Deletada"
          onConfirm={() => {
            getAllProducts();
            setDeleteSuccess(false);
          }}
        >
          Tela deletada com sucesso
        </SweetAlert>
      ) : null}
      <Modal isOpen={isOpen} centered autoFocus size="xl">
        <ModalHeader toggle={toggle}>Telas</ModalHeader>
        <ModalBody>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
              alignItems: "center",
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>

            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Pesquisar..."
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpenCollapse}
                isOpen={isOpenCollapse}
              />
              <Collapse isOpen={isOpenCollapse}>
                <Row className="mobile-btns-top">
                  <div onClick={() => setModalNewScreen(true)}>Nova Tela</div>
                </Row>
              </Collapse>
            </div>

            <div className="header-btns-container">
              <Button
                color="success"
                className="btn-rounded waves-effect waves-light events-button-add"
                onClick={() => setModalNewScreen(true)}
              >
                Nova Tela
              </Button>
            </div>
          </div>

          <div className="table-responsive mt-2 mb-3">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>ID da Tela</th>
                  <th>Tela</th>
                  <th>Nome para Governança</th>
                  <th>ID do Produto (Sistema)</th>
                  <th>Produto (Sistema)</th>
                  <th>Ações</th>
                </tr>
              </thead>

              <tbody>
                {screens &&
                  screens.length > 0 &&
                  screens
                    .filter((e) => e.mainProduct != null)
                    .map((e, i) => (
                      <tr key={i}>
                        <td>{e.id}</td>
                        <td>{e.name}</td>
                        <td>{e?.screen?.shortName}</td>
                        <td>{e.mainProduct.id}</td>
                        <td>{e.mainProduct.name}</td>
                        <td>
                          <i
                            className="mdi mdi-pencil"
                            style={{
                              color: "green",
                              fontSize: 17,
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setEditData(e);
                              setModalEditScreen(true);
                            }}
                          />
                          <i
                            className="mdi mdi-trash-can"
                            style={{
                              color: "red",
                              fontSize: 17,
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setDeleteData(e);
                              setConfirmDelete(true);
                            }}
                          />
                        </td>
                      </tr>
                    ))}
              </tbody>
            </Table>
          </div>
          <Pagination
            data={[]}
            search={search}
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
            countData={countData}
            maxItemPerPage={itemsPerPage}
            setMaxItemPerPage={setItemsPerPage}
            maxPageButtonsToShow={3}
          />
        </ModalBody>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Screens);
